var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEndurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{clip-path:url(#SVGID_00000097471426158670007370000001081394692537944212_);}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-heart",
    d: "M45.15,6.11c-5.48-4.44-13.46-3.86-18.23,1.33l-1.93,1.98l-1.93-1.98 C18.29,2.27,10.33,1.69,4.86,6.11C-1,11.17-1.65,20.02,3.41,25.89c0.15,0.18,0.31,0.35,0.48,0.53l18.9,19.51 c1.17,1.22,3.11,1.26,4.33,0.09c0.03-0.03,0.06-0.06,0.09-0.09l18.9-19.51c5.36-5.59,5.17-14.46-0.42-19.82 C45.51,6.43,45.33,6.27,45.15,6.11z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEndurance);
export default __webpack_public_path__ + "static/media/Icon_Endurance.527f22817a5875242380c3270b4d8a50.svg";
export { ForwardRef as ReactComponent };